'use client';

import { forwardRef, useState } from 'react';
import { cn } from '@/lib/utils';

const GlowInput = forwardRef(function GlowInput(
  { className, error, ...props },
  ref
) {
  const [focused, setFocused] = useState(false);

  return (
    <div
      className={cn(
        'relative rounded-xl transition-shadow duration-300',
        focused
          ? 'shadow-[0_0_25px_rgba(79,209,229,0.2)] ring-2 ring-ring/60'
          : 'shadow-[0_0_10px_rgba(79,209,229,0.05)] ring-1 ring-ring/20',
        error && 'ring-destructive/60 shadow-[0_0_15px_rgba(234,179,8,0.15)]'
      )}
    >
      <input
        ref={ref}
        className={cn(
          'w-full rounded-xl border-0 bg-card/60 px-5 py-4 text-lg font-medium text-foreground backdrop-blur-sm',
          'placeholder:text-muted-foreground/60',
          'focus:outline-none focus:ring-0',
          className
        )}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        {...props}
      />
    </div>
  );
});

export default GlowInput;
